/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SET_ACCOUNT_TYPE } from '../actions/accountTypeActions';

export const initialState = {
    accountType: 'FIT',
};

export const accountTypeReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACCOUNT_TYPE: {
            return {
                ...state,
                accountType: action.payload,
            };
        }
        default:
            return state;
    }
};
